import logo from "@/assets/icons/maqrah.png";
import {
  FaFacebook,
  FaInstagram,
  FaSquareWhatsapp,
  FaTelegram,
  FaYoutube,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import {
  aboutPath,
  academyPath,
  changePasswordPath,
  contactPath,
  blogPath,
  InstructorsPath,
  landingPath,
  studentPath,
  waitListPath,
} from "../routes/path";
import Button from "./Button";

const Footer = () => {
  return (
    <div className="bg-[#001538f2] font-[Mulish] text-white">
      <footer className=" flex sm:flex-row flex-col justify-between items-center text-sm sm:p-20 p-2 sm:px-30 mb-10 gap-y-14">
        <div className="sm:w-[60%]  flex flex-col justify-center sm:justify-start gap-y-4 items-start">
          <Link className="hover:text-[#004C97]" to={landingPath}>
            <img src={logo} alt="logo" width={50} />
          </Link>
          <p className="sm:w-[15rem] font-[Mulish] font-semibold text-2xl sm:text-sm leading-6">
            Join Over 3,000+ Happy Students Today!
          </p>
          <p className="sm:w-[15rem] font-[Roboto] font-medium text-xs sm:text-sm leading-6">
            📖 Maqrahaatu Tanzeel – Illuminating Hearts with the Quran "The best
            among you are those who learn the Quran and teach it." – Prophet
            Muhammad (ﷺ)
          </p>
          <Link
            className="mx-auto sm:mx-0"
            to={"https://forms.gle/wDeTHHiRad5U4PaY6"}
          >
            <Button
              btnText={"Enroll and Start Learning"}
              btnColor={"text-[#3b76db] hover:text-white"}
              padding={"!p-3 px-6 "}
              btnBgColor={"bg-white hover:bg-[#004C97] "}
              onClick={() => "#"}
            />{" "}
          </Link>
          <p className="sm:w-[15rem] font-[Mulish] font-semibold text-xs sm:text-sm leading-6">
            ✨ Join us in the journey of faith, knowledge, and transformation!{" "}
            <br /> <br />
            🔗 Follow us for daily Quranic wisdom:
          </p>
          <div className="flex sm:text-xl gap-5 text-xl">
            <a
              target="_blank"
              href="https://www.facebook.com/Maqrahaatultanzeel"
            >
              <FaFacebook className="text-blue-500 hover:text-blue-400" />
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/Maqrahaatultanzeel/"
            >
              <FaInstagram className="text-red-600 hover:text-red-400" />
            </a>
            <a target="_blank" href="https://wa.me/+2348153783287">
              {" "}
              <FaSquareWhatsapp className="text-green-600 hover:text-green-300" />
            </a>
            <a
              target="_blank"
              href="https://www.youtube.com/@Maqrahaatultanzeel?sub_confirmation=1"
            >
              <FaYoutube className="text-red-700 hover:text-red-300" />
            </a>
            <a target="_blank" href="https://t.me/maqrahatultanzeel">
              <FaTelegram className="text-blue-700 hover:text-blue-300" />
            </a>
          </div>
        </div>
        <div className="sm:flex grid grid-cols-2 sm:gap-5 gap-y-14 text-xs w-full sm:justify-between sm:w-full sm:text-[1rem]">
          <div className="leading-6 sm:leading-9">
            <ul>
              <p className="font-bold sm:text-[1.2rem] text-[#5893fa]">
                Academy
              </p>

              <Link className="hover:text-[#004C97]" to={academyPath}>
                <li>Our Store</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={blogPath}>
                <li>Our Blog</li>
              </Link>
            </ul>
          </div>
          <div className="leading-6 sm:leading-9">
            <ul>
              <p className="font-bold sm:text-[1.2rem]  text-[#5893fa]">
                Information
              </p>
              <Link className="hover:text-[#004C97]" to={aboutPath}>
                <li>About us</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={contactPath}>
                <li>Contact Us</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={waitListPath}>
                <li>Join Wait-List</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={blogPath}>
                <li>blogs</li>
              </Link>
            </ul>
          </div>
          <div className="leading-6 sm:leading-9">
            <ul>
              <p className="font-bold sm:text-[1.2rem] text-[#5893fa]">
                Account
              </p>
              <Link className="hover:text-[#004C97]" to={studentPath}>
                <li>Students Profile</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={`${academyPath}`}>
                <li>Affiliate Marketer</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={`${InstructorsPath}`}>
                <li>Instructor</li>
              </Link>
            </ul>
          </div>
          <div className="leading-6 sm:leading-9">
            <ul>
              <p className="font-bold sm:text-[1.2rem]  text-[#5893fa]">
                Learn the Qur'an with Ease
              </p>
              <Link className="hover:text-[#004C97]" to={changePasswordPath}>
                <li>Marketing</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={academyPath}>
                <li>Online Academy</li>
              </Link>
              <Link className="hover:text-[#004C97]" to={blogPath}>
                <li>Consulting </li>
              </Link>
            </ul>
          </div>
        </div>
      </footer>
      <div className="border-t-[1px] border-[#d8d4d4] mx-3 text-center text-white ">
        <p>💙 Let the words of Allah be your guiding light.</p>
        <div className="pb-12 pt-5 text-center text-xs">
          <p>
            © 2025{" "}
            <a target="_blank" href="https://maqrahat.vercel.app/#/">
              Maqrahaatultanzeel.com
            </a>{" "}
            | Maqrahaat Ul Tanzeel (MUT) | We love our Studentes & All Rights
            Reserved.!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
